import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import ScreenReaderOnlyText from "../../helpers/ScreenReaderOnlyText";
import BodyText from "../Typography/texts/BodyText";
import MetaText from "../Typography/texts/MetaText";
import { SizeButtonGroup } from './components/SizeButtonGroup';
import styles from './SizeSelector.module.scss';
const SizeSelector = (props) => {
    const { variants, labels, sizeButtons, isCentered, className, isComingSoon, selectedSizeCode, isSizeSelected, setSelectedSizeCode, isBopisEnabled, } = props;
    const [isFewPieceLeft, setIsFewPieceLeft] = useState(false);
    const [sizeSelectorWidth, setSizeSelectorWidth] = useState(0);
    const isOneSize = sizeButtons === 'large' && variants && variants.length === 1;
    const isNoSize = sizeButtons === 'large' && (variants === null || variants === void 0 ? void 0 : variants.length) === 1 && variants[0].sizeName === 'NOSIZE';
    const isArticleFewPieceLeft = () => {
        var _a;
        if (isNoSize) {
            setIsFewPieceLeft((_a = variants[0]) === null || _a === void 0 ? void 0 : _a.hasFewPiecesLeft);
        }
        const selectedVariant = variants.find((variant) => variant.sizeCode === selectedSizeCode);
        if (selectedVariant) {
            setIsFewPieceLeft(selectedVariant.hasFewPiecesLeft);
        }
    };
    /*   HM: maxButtons = large
    COS: maxButtons = small
    Other stories: maxButtons = xsmall */
    useEffect(() => {
        if (variants) {
            isArticleFewPieceLeft();
        }
    }, [variants, selectedSizeCode]);
    const sizeSelectorRef = React.useRef(null);
    const handleResize = useCallback(() => {
        var _a;
        const divWidth = ((_a = sizeSelectorRef === null || sizeSelectorRef === void 0 ? void 0 : sizeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        setSizeSelectorWidth(divWidth);
    }, []);
    useEffect(() => {
        if (sizeSelectorRef.current) {
            const observer = new IntersectionObserver(handleResize);
            observer.observe(sizeSelectorRef === null || sizeSelectorRef === void 0 ? void 0 : sizeSelectorRef.current);
        }
    }, [sizeSelectorRef]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        const dimensionsTimeout = setTimeout(() => {
            var _a;
            if (sizeSelectorRef.current) {
                setSizeSelectorWidth((_a = sizeSelectorRef === null || sizeSelectorRef === void 0 ? void 0 : sizeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            }
        }, 100);
        handleResize();
        return () => {
            clearTimeout(dimensionsTimeout);
            window.removeEventListener('resize', handleResize);
        };
    }, [sizeSelectorRef]);
    const isLargeButtons = sizeButtons === 'large';
    const hasNoVariant = (variants === null || variants === void 0 ? void 0 : variants.length) === 0;
    const variantsHasFewPiecesLeft = variants === null || variants === void 0 ? void 0 : variants.some((size) => size.hasFewPiecesLeft);
    const fewPieceLeftLabel = () => {
        if (isLargeButtons) {
            return (React.createElement("div", { className: styles.fewPieceLeft },
                React.createElement("div", { className: styles.dot },
                    React.createElement(ScreenReaderOnlyText, null, labels.labelFewPiecesLeft)),
                React.createElement(BodyText, { Tag: "span", className: styles.fewPieceLeftLabel, "data-testid": "pdp_fav_few_pieces_left_text" }, labels.labelFewPiecesLeft)));
        }
        return (React.createElement(MetaText, { Tag: "span", className: styles.lowInStockLabel }, labels.labelLowInStock));
    };
    const sizeLabel = () => {
        var _a;
        if (isOneSize) {
            return (React.createElement(BodyText, { Tag: "span", preamble: isLargeButtons, "data-testid": "pdp_fav_select_size_label" },
                isBopisEnabled ? labels.bopisLabelSize : labels.labelSize,
                ": ", (_a = variants[0]) === null || _a === void 0 ? void 0 :
                _a.sizeName));
        }
        return sizeButtons === 'small' ? (React.createElement(MetaText, { Tag: "span", className: styles.labelUpperCase, "data-testid": "pdp_fav_select_size_label" }, isBopisEnabled ? labels.bopisLabelSizes : labels.labelSizes)) : (React.createElement(BodyText, { Tag: "span", className: styles.sizeLabel, "data-testid": "pdp_fav_select_size_label" }, isBopisEnabled ? labels.bopisLabelSizes : labels.labelSizes));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(isCentered ? styles.sizeSubtitleCenter : styles.sizeSubtitle, sizeButtons === 'large' ? styles.labelsSpaceBetween : styles.labelsCentered, className), ref: sizeSelectorRef },
            !hasNoVariant && !isNoSize && labels && sizeLabel(),
            (variantsHasFewPiecesLeft || isFewPieceLeft) &&
                sizeButtons !== 'xsmall' &&
                !isComingSoon &&
                fewPieceLeftLabel()),
        !isSizeSelected && sizeButtons === 'large' && !isOneSize && !isComingSoon && (React.createElement(BodyText, { Tag: "span", className: styles.labelSizeNotSelected, "data-testid": "pdp_fav_select_size_error_label" }, labels.labelSizeNotSelected)),
        !isOneSize && (React.createElement(SizeButtonGroup, Object.assign({}, props, { setSelectedSizeCode: setSelectedSizeCode, sizeSelectorWidth: sizeSelectorWidth, "data-testid": "pdp_fav_size_selector_button" }))),
        isFewPieceLeft && sizeButtons === 'xsmall' && (React.createElement(BodyText, { Tag: "span", className: styles.lowInStockLabelCentered }, labels.labelLowInStock))));
};
export default SizeSelector;
//# sourceMappingURL=SizeSelector.js.map